<template>
	<div class="column_data_main">
		<el-card class="data_card">
			<div slot="header" class="card_header">
				<span class="header_title">专栏数据</span>
			</div>
			<div class="card_body">
				<!-- 搜索区域 -->
				<div class="search_section">
					<div class="search_item">
						<span class="search_label">时间:</span>
						<el-date-picker
							v-model="dateRange"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							:unlink-panels="true"
							@change="handleDateChange"
							class="date_picker"
						>
						</el-date-picker>
					</div>
					<div class="search_actions">
						<el-button type="primary" size="small" @click="handleSearch">
							查询
						</el-button>
						<el-button type="warning" size="small" @click="handleExport">
							导出
						</el-button>
					</div>
				</div>

				<!-- 数据表格 -->
				<div class="table_section">
					<el-table
						:data="tableData"
						border
						stripe
						v-loading="loading"
						style="width: 100%"
						:header-cell-style="{
							background: '#f5f7fa',
							color: '#333',
							fontWeight: 'bold',
						}"
					>
						<el-table-column
							prop="date"
							label="时间"
							align="center"
							width="150"
						>
						</el-table-column>
						<el-table-column
							prop="article_count"
							label="发表文章数"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.article_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column
							prop="article_ai_count"
							label="AI数量"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.article_ai_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column
							prop="article_normal_count"
							label="Crpyto数量"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.article_normal_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column prop="pv_count" label="专栏浏览量" align="center">
							<template slot-scope="scope">
								{{ scope.row.pv_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column
							prop="pv_ai_count"
							label="AI专栏浏览量"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.pv_ai_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column
							prop="pv_normal_count"
							label="Crpyto专栏浏览量"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.pv_normal_count || 0 }}
							</template>
						</el-table-column>

						<el-table-column
							prop="new_column_count"
							label="新增专栏数"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.article_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column
							prop="total_column_count"
							label="累计专栏数"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.total_column_count || 0 }}
							</template>
						</el-table-column>
						<el-table-column label="专栏活跃度" align="center">
							<template slot-scope="scope">
								{{
									scope.row.active_rate ? scope.row.active_rate + "%" : "0.00%"
								}}
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<div class="pagination_section">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total"
						>
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { zlData } from "@/api/article";

export default {
	name: "ColumnDataTable",
	data() {
		return {
			dateRange: [this.getLast30Days()[0], this.getLast30Days()[1]],
			startDate: this.getLast30Days()[0],
			endDate: this.getLast30Days()[1],
			loading: false,
			tableData: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			// 缓存所有类型的原始数据
			allDataCache: {
				type1: [], // 发表文章数
				type2: [], // 专栏流量
				type3: [], // 新增专栏数
				type4: [], // 累计专栏数
				type5: [], // 专栏活跃度
				type6: [], // 专栏AI类型流量
			},
		};
	},
	mounted() {
		this.loadAllData();
	},
	methods: {
		// 获取最近30天的日期范围
		getLast30Days() {
			const today = new Date();
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(today.getDate() - 30);

			const formatDate = (date) => {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, "0");
				const day = String(date.getDate()).padStart(2, "0");
				return `${year}-${month}-${day}`;
			};

			return [formatDate(thirtyDaysAgo), formatDate(today)];
		},

		// 日期变化处理
		handleDateChange(val) {
			if (val && val.length === 2) {
				this.startDate = val[0];
				this.endDate = val[1];
			} else {
				this.startDate = "";
				this.endDate = "";
			}
		},

		// 查询按钮
		handleSearch() {
			this.currentPage = 1;
			this.loadAllData();
		},

		// 加载所有类型的数据
		async loadAllData() {
			this.loading = true;
			try {
				// 并发请求所有5种类型的数据
				const promises = [1, 2, 3, 4, 5, 6].map((type) =>
					zlData({
						startDate: this.startDate,
						endDate: this.endDate,
						type: String(type),
					}),
				);

				const results = await Promise.all(promises);

				// 缓存所有数据
				results.forEach((res, index) => {
					if (res.code === 200) {
						this.allDataCache[`type${index + 1}`] = res.data || [];
					}
				});

				// 合并数据
				this.mergeTableData();
			} catch (error) {
				this.$message.error("数据加载失败");
				console.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 合并所有类型的数据到表格
		mergeTableData() {
			const dateMap = new Map();

			// 处理type1: 发表文章数
			this.allDataCache.type1.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).article_count = item.count;
				dateMap.get(item.date).article_ai_count = item.ai_count;
				dateMap.get(item.date).article_normal_count = item.normal_count;
				// dateMap.get(item.date).total_column_count = item.total_count;
			});

			// 处理type2: 专栏流量
			this.allDataCache.type2.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).pv_count = item.pv_count;
			});

			// 处理type6: AI专栏流量
			this.allDataCache.type6.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).pv_ai_count = item.pv_count;
				dateMap.get(item.date).pv_normal_count =
					dateMap.get(item.date).pv_count - item.pv_count;
			});

			// 处理type3: 新增专栏数
			this.allDataCache.type3.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).new_column_count = item.count;
			});

			// 处理type4: 累计专栏数
			this.allDataCache.type4.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).total_column_count = item.total_count;
			});

			// 处理type5: 专栏活跃度
			this.allDataCache.type5.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				const rate =
					item.total_count > 0
						? ((item.user_count / item.total_count) * 100).toFixed(2)
						: "0.00";
				dateMap.get(item.date).active_rate = rate;
				dateMap.get(item.date).active_user_count = item.user_count;
				dateMap.get(item.date).total_user_count = item.total_count;
			});

			// 转换为数组并按日期排序
			const allData = Array.from(dateMap.values()).sort(
				(a, b) => new Date(b.date) - new Date(a.date),
			);

			this.total = allData.length;

			// 分页处理
			const start = (this.currentPage - 1) * this.pageSize;
			const end = start + this.pageSize;
			this.tableData = allData.slice(start, end);
		},

		// 分页大小改变
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.mergeTableData();
		},

		// 当前页改变
		handleCurrentChange(val) {
			this.currentPage = val;
			this.mergeTableData();
		},

		// 导出Excel
		handleExport() {
			// 获取所有数据（不分页）
			const dateMap = new Map();

			// 合并所有数据（与mergeTableData相同的逻辑）
			this.allDataCache.type1.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).article_count = item.count || 0;
			});

			this.allDataCache.type2.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).pv_count = item.pv_count || 0;
			});

			this.allDataCache.type3.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).new_column_count = item.count || 0;
			});

			this.allDataCache.type4.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				dateMap.get(item.date).total_column_count = item.total_count || 0;
			});

			this.allDataCache.type5.forEach((item) => {
				if (!dateMap.has(item.date)) {
					dateMap.set(item.date, { date: item.date });
				}
				const rate =
					item.total_count > 0
						? ((item.user_count / item.total_count) * 100).toFixed(2)
						: "0.00";
				dateMap.get(item.date).active_rate = rate;
			});

			const exportData = Array.from(dateMap.values()).sort(
				(a, b) => new Date(b.date) - new Date(a.date),
			);

			// 表头
			const headers = [
				"时间",
				"发表文章数",
				"AI数量",
				"Crpyto数量",
				"专栏浏览量",
				"AI浏览量",
				"Crpyto浏览量",
				"新增专栏数",
				"累计专栏数",
				"专栏活跃度",
			];

			// 数据行
			const rows = exportData.map((item) => [
				item.date,
				item.article_count || 0,
				item.article_ai_count || 0,
				item.article_normal_count || 0,
				item.pv_count || 0,
				item.pv_ai_count || 0,
				item.pv_normal_count || 0,
				item.new_column_count || 0,
				item.total_column_count || 0,
				item.active_rate ? item.active_rate + "%" : "0.00%",
			]);

			// 创建工作表
			const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "专栏数据");

			// 生成文件
			const wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});

			// 保存文件
			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: "application/octet-stream",
					}),
					`专栏数据_${this.startDate}_${this.endDate}.xlsx`,
				);
				this.$message.success("导出成功");
			} catch (e) {
				this.$message.error("导出失败");
				console.error(e);
			}
		},
	},
};
</script>

<style scoped>
.column_data_main {
	padding: 20px;
	background-color: #f0f2f5;
	min-height: calc(100vh - 40px);
}

.data_card {
	background: #fff;
	border-radius: 8px;
}

.card_header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.header_title {
	font-size: 18px;
	font-weight: bold;
	color: #333;
}

.card_body {
	padding: 20px;
}

.search_section {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding: 15px;
	background: #f5f7fa;
	border-radius: 4px;
	gap: 20px;
}

.search_item {
	display: flex;
	align-items: center;
}

.search_label {
	margin-right: 10px;
	font-size: 14px;
	color: #606266;
	white-space: nowrap;
}

.date_picker {
	width: 380px;
}

.search_actions {
	display: flex;
	gap: 10px;
}

.table_section {
	background: #fff;
}

.pagination_section {
	margin-top: 20px;
	display: flex;
	justify-content: flex-end;
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
	.search_section {
		flex-direction: column;
		align-items: stretch;
		gap: 15px;
	}

	.search_item {
		flex-direction: column;
		align-items: stretch;
	}

	.search_label {
		margin-bottom: 5px;
	}

	.date_picker {
		width: 100%;
	}

	.search_actions {
		justify-content: center;
	}
}

/* Element UI 表格样式优化 */
::v-deep .el-table th {
	padding: 12px 0;
}

::v-deep .el-table td {
	padding: 10px 0;
}

::v-deep .el-table--border th,
::v-deep .el-table--border td {
	border-right: 1px solid #ebeef5;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
	background: #fafafa;
}

::v-deep .el-table__body tr:hover > td {
	background-color: #e6f7ff !important;
}
</style>
